import styled from 'styled-components';
import { StyledPopupWidgetCon, StyledProductItemCon } from '../../../../skins';

export const StyledSlideoutBundlePopupWidgetCon = styled(
  StyledPopupWidgetCon,
)``;

export const StyledSlideoutBundleProductItemCon = styled(StyledProductItemCon)`
  & .mr-product-item__body {
    justify-content: start;
  }
`;
